export default "__VITE_ASSET__BDQ7ifgP__"